import type { BopCarBop } from "../generated/graphql";

export type BopFieldValue = BopCarBop[keyof BopCarBop];

type bopFieldLabelEntry = { label: string; unit?: string };
export type bopFieldKey = keyof Omit<BopCarBop, "__typename">;

export const BopFieldLabelConfig: Record<bopFieldKey, bopFieldLabelEntry> = {
  xAirRestrictorMax: { label: "Air restrictor max", unit: "mm" },
  rLambdaMin: { label: "Lambda min" },
  xFuelRestrictorMax: { label: "Fuel restrictor max", unit: "mm" },
  xRefuelRestrictorMax: { label: "Refuel restrictor max", unit: "mm" },
  pEngineBoost: { label: "Engine boost", unit: "psi" },

  mCarBallastMin: { label: "BoP ballast min", unit: "kg" },
  mCarWeightEmptyMin: { label: "Min empty car weight", unit: "kg" },
  mCarWeightTotalMin: { label: "Min total car weight", unit: "kg" },

  mFuelMassCapacityMax: { label: "Max fuel capacity (mass)", unit: "kg" },
  mRefuelMassMax: { label: "Max refuel (mass)", unit: "kg" },
  VFuelVolumeCapacityMax: { label: "Max fuel capacity (vol)", unit: "L" },
  VRefuelVolumeMax: { label: "Max refuel (vol)", unit: "L" },

  PEngineMax: { label: "Max engine power", unit: "kW" },
  nEngineMax: { label: "Max engine RPM", unit: "rpm" },
  vCarMax: { label: "Max car speed", unit: "km/h" },
  rPowerCurveReference: { label: "Max power curve ref velocity", unit: "kph" },
  vPowerCurveBelowRefVelocity: { label: "Max power curve below X kph", unit: "peak" }, // currently static labels for X
  vPowerGainReference: { label: "Power gain ref velocity", unit: "kph" },
  rPowerGainAboveRefVelocity: { label: "Power gain above Y kph", unit: "%" }, // currently static labels for Y
  EStintMax: { label: "Maximum stint energy", unit: "MJ" },

  hRideFmin: { label: "Min front ride height", unit: "mm" },
  hRideRmin: { label: "Min rear ride height", unit: "mm" },

  aRakeMin: { label: "Min rake", unit: "deg" },
  aRakeMax: { label: "Max rake", unit: "deg" },
  aWingRmin: { label: "Min rear wing", unit: "deg" },
  aWingRmax: { label: "Max rear wing", unit: "deg" },
  zWingMin: { label: "Min Z rear wing", unit: "mm" },

  aCamberFmin: { label: "Min front camber", unit: "deg" },
  aCamberFmax: { label: "Max front camber", unit: "deg" },
  aCamberRmin: { label: "Min rear camber", unit: "deg" },
  aCamberRmax: { label: "Max rear camber", unit: "deg" },

  carSpec: { label: "Car spec" },
  make: { label: "Manufacturer" },
  modelYear: { label: "Model year" },
  homologation: { label: "Homologation" },

  highlightColour: { label: "Car label colour" },
  _id: { label: "Internal ID" },
};
